<ng-container *notInPopulation="[populations.Pts]"
  ><fgb-banner [title]="'fgbcl.refer.a.friend' | translate"></fgb-banner>

  <div class="d-block d-lg-none">
    <fgb-page-header
      [pageTitle]="'account.page.title'"
      [backButtonLink]="'/'"
      [showQr]="!isSuiteOrPts"
      [showBalance]="!isSuiteOrPts"
    ></fgb-page-header>
  </div>

  <fgb-account-nav></fgb-account-nav>

  <div class="container mt-3 pb-lg-0 pb-4">
    <div class="card bg-white rounded">
      <img class="rounded-4 refer-img-mob" src="assets/images/ReferaFriend.png" />
      <span class="font-size-14">
        {{ 'fgbcl.refer.friend.invite.link.label' | translate }}
      </span>
      <d-flex class="flex-column d-flex gap-2">
        <div class="refer-a-friend-copy">
          <div class="p-3 rounded-4 d-flex my-card--wrapper">
            <div class="linkurl">
              <span class="font-size-14" #copyToClipboard>{{ linktoggle ? 'Link Copied' : url }}</span>
            </div>
            <div class="text-end">
              <a
                type="button"
                data-bs-toggle="button"
                autocomplete="off"
                aria-pressed="true"
                class="my-card--copy fw-bold"
                (click)="copyCodeToClipboardLowercase(url)"
                (keydown.enter)="copyCodeToClipboardLowercase(url)"
                tabindex="0"
              >
                <img width="24" height="25" src="assets/images/icons/secondary-icon-copy.png" />
              </a>
            </div>
          </div>
          <div class="p-3 d-flex my-card--wrapper code-refer">
            <div class="d-flex flex-row">
              <span class="font-size-14 text-black" *ngIf="!toggle">
                {{ 'referral.code.message' | translate }}
              </span>
              <span class="ms-1 font-size-14 fw-bold text-black referral-code" #copyToClipboard>
                {{ toggle ? 'Code Copied' : code }}
              </span>
            </div>
            <div class="text-end">
              <a
                type="button"
                data-bs-toggle="button"
                autocomplete="off"
                aria-pressed="true"
                class="my-card--copy fw-bold"
                (click)="copyCodeToClipboardLowercaseCode(code)"
                (keydown.enter)="copyCodeToClipboardLowercaseCode(code)"
                tabindex="0"
              >
                <img width="24" height="25" src="assets/images/icons/secondary-icon-copy.png" />
              </a>
            </div>
          </div>
        </div>
        <!-- Divider -->
        <div>
          <hr class="separator" />
          <span class="orSpan font-size-14 text-info">{{ 'refer.a.friend.or' | translate }}</span>
        </div>
        <div class="col-12">
          <form [formGroup]="referAFriendForm">
            <div class="form-floating">
              <input
                type="email"
                class="form-control text-email font-size-14"
                formControlName="email"
                id="floatingEmailValue"
                placeholder="name@example.com"
              />
              <label class="font-size-14 fw-normal" for="floatingEmailValue">{{ 'fgbcl.refer.email.address' | translate }}</label>
            </div>
          </form>
          <div class="justify-content-center text-center mt-3 fw-bold">
            <button
              role="submit"
              class="btn btn-success fw-bold"
              [disabled]="successFlag || !referAFriendForm?.valid"
              (click)="sendReferral(referAFriendForm.value)"
            >
              {{ 'fgbcl.refer.friend.submit' | translate }}
            </button>
          </div>
          <div class="text-success font-size-12 text-center" *ngIf="successFlag">
            {{ 'refer.submit.success' | translate }}
          </div>
        </div>
      </d-flex>
    </div>
  </div>
</ng-container>

<ng-container *inPopulation="[populations.Pts]">
  <fgb-not-found-page></fgb-not-found-page>
</ng-container>
